<template>
  <div class="container">
    <div class="main">
      <div class="search-box-header">工作人员查询</div>
      <div class="search-box">
        <div style="text-align:center;">
          <img src="@/assets/APP ICON.png" style="width:75px; height:75px" />
        </div>
        <div style="text-align:center;font-size:12px">中国旅游TV</div>
        <div style="margin-top:30px;margin-bottom:5px;">职工姓名</div>
        <div>
          <el-input v-model="empName"></el-input>
        </div>
        <div style="margin-top:10px;margin-bottom:5px;">证件编号</div>
        <div>
          <el-input v-model="empCode"></el-input>
        </div>
        <div style="text-align:center;margin-top:40px;margin-bottom:5px;">
          <el-button type="primary" @click="search">查询</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request, { getEmployees } from "@/utils/request";
export default {
  layout: "blank",
  data() {
    return {
      empName: "",
      empCode: ""
    };
  },
  methods: {
    search() {
      getEmployees({
        empName: this.empName,
        empCode: this.empCode
      }).then(res => {
        if (res.code !== 0) {
          this.$message({
            message: "未找到此员工",
            type: "warning",
            duration: 1000
          });
        } else {
          this.$router.push({
            path: `/workcard/show/${res.data.id}`,
            query: { empName: res.data.empName, empCode: res.data.empCode }
          });
        }
      });
    }
  }
};
</script>


<style>
body {
  background-color: #e0e4e8;
}
.container {
  margin: 0 auto;
  padding: 80px 0;
  min-height: 100%;
}
.main {
}
.search-box-header {
  margin: 0 auto;
  width: 360px;
  height: 55px;
  padding-top: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  text-align: center;
  color: white;
  font-size: 20px;
  background-color: #3a8ee6;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.search-box {
  margin: 0 auto;
  width: 360px;
  height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background-color: #f6f6f6;
  padding: 10px 20px;
}
</style>